// Normalisation E.164 des numéros (Lot 2).
// Bénin : +229 + 10 chiffres commençant par 01 (format en vigueur depuis nov. 2020).
//   Les anciens numéros à 8 chiffres sont mis à niveau en préfixant "01".
// Togo  : +228 + 8 chiffres.

const DIAL = { Benin: '229', Togo: '228' };

function digitsOnly(s) {
  return String(s || '').replace(/\D/g, '');
}

function beninNational(nat) {
  let d = nat;
  if (d.length === 8) d = `01${d}`; // ancien format 8 chiffres -> 10 chiffres
  if (d.length === 10 && d.startsWith('01')) return d;
  return null;
}

function togoNational(nat) {
  return nat.length === 8 ? nat : null;
}

// Renvoie le numéro E.164 canonique (ex. +2290196123456) ou null si non normalisable.
export function normalizePhone(raw, country) {
  const dial = DIAL[country] || DIAL.Benin;
  let d = digitsOnly(raw);
  if (!d) return null;
  if (d.startsWith(`00${dial}`)) d = d.slice(2); // 00 international
  if (d.startsWith(dial)) d = d.slice(dial.length); // indicatif déjà présent
  const nat = dial === '229' ? beninNational(d) : dial === '228' ? togoNational(d) : d || null;
  return nat ? `+${dial}${nat}` : null;
}

export function isValidPhone(raw, country) {
  return normalizePhone(raw, country) !== null;
}

// Indicatif d'affichage (pour l'UI).
export function dialPrefix(country) {
  return `+${DIAL[country] || DIAL.Benin}`;
}
